import { 
  ITableRes, 
  IFinalGrade,
  IFinalGradeParams,
  IFinalGradeData
} from 'types'
import { baseApi } from './baseApi'

export const coursesAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    //Course
    GET_finalGrades: builder.query<ITableRes<IFinalGrade>, IFinalGradeParams>({
      query: (params) => ({
        url: '/final-grades/',
        params,
      }),
      providesTags: ['final-grades','gradebook-grid'],
    }),
    POST_gradeCourseComponent: builder.mutation<IFinalGrade, {id: string; body: IFinalGradeData}>({
      query: ({id, body}) => ({
        url: `/grade-course-component/${id}/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['final-grades','gradebook-grid'],
    }),
    POST_gradeAcademicPeriod: builder.mutation<IFinalGrade, {id: string; body: IFinalGradeData}>({
      query: ({id, body}) => ({
        url: `/grade-academic-period/${id}/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['final-grades','gradebook-grid'],
    }),
    POST_gradeFinal: builder.mutation<IFinalGrade, {id: string; body: IFinalGradeData}>({
      query: ({id, body}) => ({
        url: `/grade-final/${id}/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['final-grades','gradebook-grid'],
    }),
  }),
})

export const { 
  useGET_finalGradesQuery, 
  usePOST_gradeCourseComponentMutation,
  usePOST_gradeAcademicPeriodMutation, 
  usePOST_gradeFinalMutation, 
} = coursesAPI
